import { getStore } from '../store/store';

/**
 * Indicates whether the user has ever selected calendars in Time Panel
 *
 * If not, we should fall back on using Calendar Module selected calendars config
 */
export function hasTimePanelSelectedCalendars(): boolean {
    const selectedCalendarsMap = getStore().calendarIdsMap;

    let calendarsCount = 0;
    for (let value of selectedCalendarsMap.values()) {
        if (value) {
            calendarsCount += value.length;
        }
    }

    return calendarsCount > 0;
}
